export const getValueOrDefault = <T>(
	value: T | null | undefined,
	defaultValue: T
): T => value || defaultValue;
